import type { RegionCode } from '~/api/aspida/@types';
import type { Languages } from '~/interfaces/common';

// AAF 圏（jp 以外）は en-XX しか受け付けないため lang に関わらず en に寄せる。
// jp の場合のみ ja / en を切り替え（ar は en として扱う）
export const getOALocale = (regionCode: RegionCode, lang: Languages): string => {
  const oaLang = regionCode === 'jp' ? (lang === 'ar' ? 'en' : lang) : 'en';
  return `${oaLang}-${regionCode.toUpperCase()}`;
};

const buildQueryObject = (locale: string) => ({
  client_id: process.env.NEXT_PUBLIC_AUTH_CLIENT_ID ?? '',
  locale,
  grant_type: 'code',
  style: 'stepnote',
  redirect_uri: encodeURIComponent(process.env.NEXT_PUBLIC_AUTH_REDIRECT_URI ?? ''),
  privacy_url: encodeURIComponent('https://stepnote.asics.com/policy.html'),
  terms_url: encodeURIComponent('https://stepnote.asics.com/term.html'),
  oneasics_terms_url: encodeURIComponent(
    'https://www.asics.com/us/en-us/mk/oneasics-terms-and-conditions',
  ),
  region: 'Global',
  cookie_url: encodeURIComponent('https://www.asics.com/us/en-us/cookie-policy.html!new'),
});

const buildAuthQueryString = (locale: string) => {
  const params = new URLSearchParams({
    ...buildQueryObject(locale),
    no_confirm_email: 'true',
    send_confirm_email: 'false',
  });
  return '?' + params.toString();
};

export const authConstants = {
  BASE_URL: process.env.NEXT_PUBLIC_AUTH_URL,
  REGISTER_PATH: '/lander',
  LOGIN_PATH: '/login',
  buildRegisterQueryStrings: buildAuthQueryString,
  buildLoginQueryStrings: buildAuthQueryString,
};
